import { BasePeerToPeerCampaignAction } from "./BasePeerToPeerCampaignAction";

import { FormButton } from "@/forms-design-system/FormButton/FormButton";
import { useTranslate } from "@/hooks/useTranslate";
import { ArrowDiagonalRight } from "@/icons/outlined";
type PeerToPeerPrimaryCampaignFundraiseCampaignActionProps = {
  canCreateTeamCampaigns: boolean;
  canJoinTeamCampaigns: boolean;
  canCreateIndividualCampaigns: boolean;
  hasRegistration: boolean;
  onClick?: () => void;
};

export const PeerToPeerPrimaryCampaignFundraiseCampaignAction = ({
  canCreateTeamCampaigns,
  canJoinTeamCampaigns,
  canCreateIndividualCampaigns,
  hasRegistration,
  onClick,
}: PeerToPeerPrimaryCampaignFundraiseCampaignActionProps) => {
  const { t } = useTranslate();

  const getDescription = () => {
    if (hasRegistration) {
      return t("donationForm", "peerToPeer.description.fundraiseOnly");
    }

    if (canCreateTeamCampaigns && canJoinTeamCampaigns && canCreateIndividualCampaigns) {
      return t("donationForm", "peerToPeer.description.createTeamJoinOrSolo");
    }

    if (canCreateTeamCampaigns && canJoinTeamCampaigns && !canCreateIndividualCampaigns) {
      return t("donationForm", "peerToPeer.description.createTeamOrJoin");
    }

    if (canCreateTeamCampaigns && !canJoinTeamCampaigns && canCreateIndividualCampaigns) {
      return t("donationForm", "peerToPeer.description.createTeamOrSolo");
    }

    if (canCreateTeamCampaigns && !canJoinTeamCampaigns && !canCreateIndividualCampaigns) {
      return t("donationForm", "peerToPeer.description.createTeam");
    }

    if (!canCreateTeamCampaigns && canJoinTeamCampaigns && canCreateIndividualCampaigns) {
      return t("donationForm", "peerToPeer.description.joinTeamOrSolo");
    }

    if (!canCreateTeamCampaigns && canJoinTeamCampaigns && !canCreateIndividualCampaigns) {
      return t("donationForm", "peerToPeer.description.joinTeam");
    }

    if (!canCreateTeamCampaigns && !canJoinTeamCampaigns && canCreateIndividualCampaigns) {
      return t("donationForm", "peerToPeer.description.createCampaign");
    }

    throw new Error("Cannot fundraise if none of the options are allowed");
  };

  return (
    <BasePeerToPeerCampaignAction
      title={t("donationForm", "peerToPeer.title.wantToFundraise")}
      description={getDescription()}
      slots={{
        button: (
          <FormButton variant="outline" endIcon={<ArrowDiagonalRight />} onClick={onClick} data-test="fundraise-button">
            {t("donationForm", hasRegistration ? "peerToPeer.button.fundraiseOnly" : "peerToPeer.button.fundraise")}
          </FormButton>
        ),
      }}
    />
  );
};
